import React from 'react';
import PropTypes from 'prop-types';
import {
  InputContainer,
  Input,
  ErrorText,
  InnerContainer,
  Textarea,
} from './styledComponents';

/**
 * RyderInput Component documentation
 * @property       {string} label Input's label text
 * @property       {string} name Input's name text
 * @property       {string} value Prop to assing value to Input
 * @property       {string} type Input's type, default is "text"
 * @property       {string} placeholder Input's placeholder
 * @property       {string} errorText Error text that will display if needed
 * @property       {bool} required Indicate if the input is required or not
 * @property       {func} onChange Function to handle onChange event
 * @property       {string} className Class for Styles
 * @property       {bool} multiline Props to allow multiline
 * @property       {bool} rows Rows quantity when multiline es true
 * @property       {string} maxLength Quantity of characters
 *
 */

function RyderInput(props) {
  const {
    label,
    name,
    type,
    placeholder,
    required,
    value,
    onChange,
    errorText,
    className,
    multiline,
    rows,
    maxLength,
  } = props;
  const onChangeHandler = (event) => {
    const text = event.target.value;
    onChange(text, name);
  };
  return (
    <InputContainer className={className}>
      <label htmlFor={name}>{label}{required && <span className="required-mark">*</span>}</label>
      <InnerContainer className={className}>
        {
          !multiline ?
          <Input
            name={name}
            type={type}
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={onChangeHandler}
            maxLength={maxLength}
          /> :
          <Textarea
            name={name}
            required={required}
            value={value}
            onChange={onChangeHandler}
            rows={rows}
            maxLength={maxLength}
          />
        }
        { errorText !== '' && <ErrorText>{errorText}</ErrorText>}
      </InnerContainer>
    </InputContainer>
  );
}

RyderInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  className: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  maxLength: PropTypes.string,
};

RyderInput.defaultProps = {
  type: 'text',
  value: '',
  required: false,
  errorText: '',
  className: '',
  rows: '',
  multiline: false,
};

export default RyderInput;



// WEBPACK FOOTER //
// ./src/components/RyderInput/index.js